module.exports = __webpack_public_path__ + "lp/img/zoom_in_disabled.48e46553.svg";